import React from 'react';
import { ThemeProvider } from '@paypalcorp/pp-react-theme';

function withTheme(WrappedComponent, theme = 'v2') {
  const ThemedComponent = (props) => {
    return (
      <ThemeProvider theme={theme}>
        <WrappedComponent {...props} />
      </ThemeProvider>
    );
  };
  return ThemedComponent;
}

export default withTheme;
